<template>
  <!-- 添加学校****弹框 -->
  <div class="small-dialog slider-addGraden">
    <el-dialog
      title="添加班种"
      :visible="addSuitClassVisible"
      width="900px"
      v-if="addSuitClassVisible"
      @close="handleCloseFrame()"
    >
      <div class="dialog-content">
        <div class="flex-wrap">
          <div class="flex-al mb12 mr10">
            <el-select
              clearable
              filterable
              @change="keywordChange"
              v-model="add_school_json.coursetype_id"
              placeholder="请选择班组"
            >
              <el-option
                v-for="(item, index) in courseTypeList"
                :key="index"
                :value="item.coursetype_id"
                :label="item.coursetype_cnname"
              ></el-option>
            </el-select>
          </div>
          <div class="flex-al Inquire-box mb12">
            <div class="ipt-box" style="width:280px;">
              <el-input
                @clear="keywordChange"
                @keyup.enter.native="keywordChange"
                v-model="add_school_json.keyword"
                clearable
                placeholder="请输入班组名称、编号，班种编号"
              ></el-input>
            </div>
            <el-button
              @click="keywordChange"
              type="primary"
              size="small"
              class="search-btn fs14"
            >
              查询
            </el-button>
          </div>
        </div>
        <div class="tableDiv">
          <noBorderTableCont
            :tableData="tableAddSuitGraden"
            @handleSelectionChange="handleSelectionChange"
          ></noBorderTableCont>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="flex-all">
          <span class="fs14"> 适配班种数量：{{ suitList.length }}</span>
          <span>
            <el-button
              :disabled="suitList.length == 0"
              type="primary"
              size="mini"
              @click="handEditClassConfirm()"
            >
              确定
            </el-button>
            <el-button size="mini" @click="handleCloseFrame">
              取消
            </el-button>
          </span>
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import noBorderTableCont from "@/components/tables/noBorderTableCont.vue";
export default {
  name: "addSuitClassVisible",
  props: ["addSuitClassVisible", "tableListGraden", "infomationData"],
  data() {
    return {
      courseTypeList: [],
      // 添加适用学校表格数据
      tableAddSuitGraden: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: true, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: "300px", //表格高度
        },
      },
      //筛选******添加适用学校表格数据
      add_school_json: {
        coursetype_id: "",
        keyword: "",
      },
      suitList: [], //选择的学校
    };
  },
  components: {
    noBorderTableCont,
  },
  created() {
    this.add_school_json = {
      coursetype_id: "",
      keyword: "",
    }; //数据清空
    this.courseTypeRecruitApi();
    this.ActivityCoursecatApi(this.infomationData.activity_id, "0");
  },
  computed: {
    getaddSuitGraden() {
      return this.addSuitClassVisible;
    },
  },
  methods: {
    courseTypeRecruitApi() {
      this.$http.courseTypeRecruitApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.courseTypeList = [...data.list];
        } else {
          this.courseTypeList = [];
        }
      });
    },
    ActivityCoursecatApi(id, type) {
      this.$http
        .ActivityCoursecatApi({
          activity_id: id,
          is_count: "1", //是否统计总数
          p: this.tableAddSuitGraden.curPage,
          num: "100000",
          adaptive: type, //是否适配 0 筛选不是配的 1 筛选已经适配的
          // 数据筛选
          coursetype_id: this.add_school_json.coursetype_id,
          keyword: this.add_school_json.keyword,
          school_type: "",
        })
        .then((res) => {
          (() => {})(res);
          this.tableAddSuitGraden.options.errortip = res.data.msg;
          this.tableAddSuitGraden.columns = res.data.data.field;
          if (res.data.code === 200) {
            if (type == "0") {
              this.tableAddSuitGraden.list = res.data.data.data;
            }
          } else {
            this.tableAddSuitGraden.list = [];
          }
        });
    },

    keywordChange() {
      this.ActivityCoursecatApi(this.infomationData.activity_id, "0");
    },

    // 复选框*****添加适用学校表格数据
    handleSelectionChange(val) {
      (() => {})(val, 4564565);
      this.suitList = val;
    },
    // 确定提交
    handEditClassConfirm() {
      this.$emit("handEditClassConfirm", this.suitList);
    },
    // 关闭弹框
    handleCloseFrame() {
      this.$emit("handleCloseFrame");
    },
  },
};
</script>

<style lang="less">
// 添加学校样式
.slider-addGraden {
  .el-dialog__body {
    padding: 12px 20px;
  }
}
</style>
